import axios from "axios";
import Cookies from "js-cookie";
import { administrativeError } from "./administrativeError";
import { FIRMFLOWURL } from "./url";

export async function createEmployee(form) {
    const payload = {
        firstName: form.first_name,
        lastName: form.last_name,
        email: form.email,
        role: form.role,
        createPasswordNow: Boolean(form.createPasswordNow),
    };
    if (form.createPasswordNow) payload.password = form.password;

    try {
        const response = await axios.post(`${FIRMFLOWURL}api/Employee/firm/employee`, payload, {
            headers: { Authorization: Cookies.get("Bearer") },
            suppressForbiddenToast: true,
            timeout: 30000,
        });
        // Development responses can contain an invitationUrl. Drop it here.
        return { success: true, data: { success: response.data.success, message: response.data.message } };
    } catch (error) {
        return administrativeError(error, "Unable to create the employee. Check the current employee list before trying again.");
    }
}
